import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Thumbs, Autoplay, FreeMode } from 'swiper/modules';


let thumbsSwiper;

const thumbs = new Swiper(".investment-slider__thumbs", {
  modules: [FreeMode, Thumbs],
  spaceBetween: 10,
  autoplay: true,
  watchSlidesProgress: true,
  freeMode: false,
  allowTouchMove: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  centeredSlides: false,
  touchRatio: 0.2,

});



const hero = new Swiper(".investment-slider__swiper", {
  modules: [Navigation, Pagination, EffectFade, Thumbs],
  loop: true,
  effect: "fade",
  allowTouchMove: true,
  slidesPerView:1,
  centeredSlides: true,


  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  thumbs: {
    swiper: thumbs,
  },
});

const gallery = new Swiper(".gallery-slider__swiper", {
  modules: [Navigation, Pagination, EffectFade, Thumbs],
  loop: false,
  effect: "fade",
  allowTouchMove: true,
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  }
});

const values = new Swiper(".values", {
	modules: [Navigation, Pagination],

	slidesPerView: 1.1,
	spaceBetween: 16,
	loop: true,

	breakpoints: {
	  767: {
		slidesPerView: 2.3,
		spaceBetween: 32,
	  },

	  990: {
		slidesPerView: 2.3,
		spaceBetween: 32,
	  },

	  1280: {
		slidesPerView: 2.1,
		spaceBetween: 32,
	  },

	   1440: {
		slidesPerView: 2.6,
		spaceBetween: 32,
	  },

	   1560: {
		slidesPerView: 2.8,
		spaceBetween: 32,
	  },

	   1720: {
		slidesPerView: 3.1,
		spaceBetween: 32,
	  },
	},

	navigation: {
		nextEl: ".swiper-button-next-values",
		prevEl: ".swiper-button-prev-values",
	  },


});

const galleryThumbs = new Swiper('.gallery-thumbs', {
  modules: [FreeMode, Thumbs],
  spaceBetween: 10,
  slidesPerView: 'auto',
  touchRatio: 0.2,
  slideToClickedSlide: true,
  loop: true,
  loopedSlides: 4,
});

const galleryTop = new Swiper('.gallery-top', {
  modules: [Navigation, Pagination, EffectFade, Thumbs],

  thumbs: {
    swiper: galleryThumbs,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
   pagination: {
    el: '.swiper-pagination', // selektor elementu paginacji
    clickable: true,          // czy można klikać w paginację
  },

  loop: true,
  loopedSlides: 4,
});

// Opcjonalnie, dodaj kontrolę synchronizacji ręcznie, jeśli wymaga tego wersja Swiper:
// Nie jest to konieczne, jeśli korzystasz z `thumbs` i `controller`, ale w wersjach bez tego można zrobić tak:

// Użycie controller (jeśli Twoja wersja Swiper obsługuje to):
// galleryTop.controller.control = galleryThumbs;
// galleryThumbs.controller.control = galleryTop;

// Tylko obsługa zmiany głównego slidera:
galleryTop.on('slideChange', () => {
  const index = galleryTop.realIndex;
  galleryThumbs.slideToLoop(index);
});





